import { render, staticRenderFns } from "./ClientFactoringCompany.vue?vue&type=template&id=129f4657&scoped=true&"
import script from "./ClientFactoringCompany.vue?vue&type=script&lang=js&"
export * from "./ClientFactoringCompany.vue?vue&type=script&lang=js&"
import style0 from "./ClientFactoringCompany.vue?vue&type=style&index=0&id=129f4657&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129f4657",
  null
  
)

export default component.exports